export const RESET = 'EXCMAGREEMENTCONSENT_LIST_RESET'
export const SET_ITEMS = 'EXCMAGREEMENTCONSENT_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMAGREEMENTCONSENT_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMAGREEMENTCONSENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMAGREEMENTCONSENT_LIST_TOGGLE_LOADING'
